var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters } from "vuex";
import MessageService from "../../api/MessageService";
import { toDetail } from "../../helper/util";
import { EBillType, EMessageTypeConfig } from "../../enum/EBillType";
import { EBusinessMsgTypeConfig } from "../../enum/EBusinessType";
import DownMessageTmpl from './DownMessageTmpl.vue';
import DemandDetailDialog from './DemandDetailDialog.vue';
import DemandService from '../../api/DemandService';
import GlobalVue from "../../globalVue";
var DOWNLOAD_MSG;
(function (DOWNLOAD_MSG) {
    DOWNLOAD_MSG[DOWNLOAD_MSG["DOWNLOAD_MORE_10000"] = 100] = "DOWNLOAD_MORE_10000";
    DOWNLOAD_MSG[DOWNLOAD_MSG["DOWNLOAD_MORE_10001"] = 101] = "DOWNLOAD_MORE_10001";
    DOWNLOAD_MSG[DOWNLOAD_MSG["DOWNLOAD_MORE_10002"] = 102] = "DOWNLOAD_MORE_10002";
})(DOWNLOAD_MSG || (DOWNLOAD_MSG = {}));
var ENoAuthPage;
(function (ENoAuthPage) {
    ENoAuthPage[ENoAuthPage["DetailRichText"] = 160] = "DetailRichText";
})(ENoAuthPage || (ENoAuthPage = {}));
var EDemandMsg;
(function (EDemandMsg) {
    EDemandMsg[EDemandMsg["DEMAND_DETAIL"] = 80] = "DEMAND_DETAIL";
})(EDemandMsg || (EDemandMsg = {}));
var MessageItem = (function (_super) {
    __extends(MessageItem, _super);
    function MessageItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageItem.prototype.created = function () {
        this.service = MessageService.getInstance();
        this.demandService = DemandService.getInstance();
    };
    MessageItem.prototype.handleMessageClick = function (message) {
        console.log('🖱️ 消息被点击:', message);
        console.log('🔍 检查点击条件:');
        console.log('- serviceFlag:', this.serviceFlag);
        console.log('- serviceDataList:', this.serviceDataList);
        console.log('- power_key:', message.notice_params && message.notice_params.power_key);
        console.log('- power_key index in serviceDataList:', this.serviceDataList ? this.serviceDataList.indexOf(message.notice_params && message.notice_params.power_key) : 'serviceDataList is null');
        var powerKey = message.notice_params && message.notice_params.power_key;
        var shouldCallToBill = !this.serviceFlag && this.serviceDataList && this.serviceDataList.indexOf(powerKey) === -1;
        console.log('- 原始条件满足:', shouldCallToBill);
        if (shouldCallToBill) {
            console.log('✅ 调用 toBill 方法');
            this.toBill(message);
        }
        else {
            console.log('❌ 条件不满足，无法调用 toBill');
            console.log('🧪 临时测试：直接调用 toBill');
            this.toBill(message);
        }
    };
    MessageItem.prototype.toBill = function (row) {
        var _this = this;
        if (row.is_valid === 0) {
            this.$message.warning("消息已失效，暂无法查看该单据");
            this.changeStatus(row, function () {
                _this.$emit("refresh");
            });
            return;
        }
        var noJump = [EBillType.Invite, EBillType.Good, EBillType.Supplier];
        var downloadTypes = [DOWNLOAD_MSG.DOWNLOAD_MORE_10000, DOWNLOAD_MSG.DOWNLOAD_MORE_10001, DOWNLOAD_MSG.DOWNLOAD_MORE_10002];
        if (downloadTypes.indexOf(row.notice_params.type) != -1) {
            this.filterDownMsg(row);
            return;
        }
        ;
        if (row.notice_params.type == ENoAuthPage.DetailRichText) {
            this.updateHomeShow(false);
            toDetail(row.notice_params.type, row.notice_id);
            this.changeStatus(row, function () {
                _this.$emit("refresh");
            });
            return;
        }
        ;
        console.log('🔍 MessageItem Debug Info:');
        console.log('- Full Message Object:', row);
        console.log('- notice_params exists:', !!row.notice_params);
        if (row.notice_params) {
            console.log('- Message Type:', row.notice_params.type);
            console.log('- Message Type (typeof):', typeof row.notice_params.type);
            console.log('- Expected Type:', EDemandMsg.DEMAND_DETAIL);
            console.log('- Expected Type (typeof):', typeof EDemandMsg.DEMAND_DETAIL);
            console.log('- Type Match (==):', row.notice_params.type == EDemandMsg.DEMAND_DETAIL);
            console.log('- Type Match (===):', row.notice_params.type === EDemandMsg.DEMAND_DETAIL);
            if (row.notice_params.type == EDemandMsg.DEMAND_DETAIL) {
                console.log('✅ 匹配到商机消息，准备显示详情弹窗');
                this.showDemandDetail(row);
                this.changeStatus(row, function () {
                    _this.$emit("refresh");
                });
                return;
            }
            if (row.type_text === '业务通知' && row.notice_title && row.notice_title.includes('商机')) {
                console.log('🧪 临时测试：检测到包含商机关键字的业务通知，尝试弹窗');
                this.showDemandDetail(row);
                this.changeStatus(row, function () {
                    _this.$emit("refresh");
                });
                return;
            }
            console.log('❌ 消息类型不匹配，跳过商机处理');
        }
        else {
            console.log('❌ notice_params 不存在');
        }
        if (row.type === 1 || noJump.indexOf(row.notice_params.type) != -1) {
            if (row.type === 1 && row.notice_params.type == 93) {
                this.getAuth('16007').then(function (pageAuth) {
                    if (pageAuth && pageAuth.Auth) {
                        GlobalVue.$emit("addTab", {
                            component: EBusinessMsgTypeConfig[row.notice_params.type].comp,
                            title: EBusinessMsgTypeConfig[row.notice_params.type].title,
                            name: "service",
                            showExist: true,
                            cprops: {
                                service_setting: pageAuth.Auth.ServiceSetting
                            }
                        });
                    }
                    else {
                        _this.$message.error("接口服务页面没有查看权限");
                    }
                });
            }
            else {
                this.$alert(row.notice_content, "提示", {}).then(function (res) {
                    _this.changeStatus(row, function () {
                        _this.$emit("refresh");
                    });
                }, function (err) {
                    _this.changeStatus(row, function () {
                        _this.$emit("refresh");
                    });
                });
            }
        }
        else {
            var notice_params_1 = row.notice_params;
            if (notice_params_1.type === 12) {
                this.$emit('toWarnDetail', row);
                this.changeStatus(row, function () {
                    _this.$emit("refresh");
                });
                return;
            }
            this.getAuth(notice_params_1.power_key).then(function (pageAuth) {
                if (pageAuth && pageAuth.Auth.LookDetail) {
                    if (row.notice_params.type !== 9)
                        _this.updateHomeShow(false);
                    if (row.notice_params.order_id) {
                        if (row.notice_params.type === 9) {
                            _this.service.getNoticeCheck({ type: 9, order_id: row.notice_params.order_id }).then(function (res) {
                                if (res.data.success) {
                                    _this.updateHomeShow(false);
                                    toDetail(row.notice_params.type, row.notice_params.order_id);
                                }
                                else {
                                    _this.$message.error(res.data.msg);
                                }
                            }).catch(function (err) {
                                _this.$message.error(err.message);
                            });
                            return;
                        }
                        toDetail(row.notice_params.type, row.notice_params.order_id, _this, row.jump_params);
                    }
                    else {
                        GlobalVue.$emit("addTab", {
                            component: EBusinessMsgTypeConfig[row.notice_params.type].comp,
                            title: EBusinessMsgTypeConfig[row.notice_params.type].title,
                            name: "service",
                            showExist: true
                        });
                    }
                }
                else {
                    var title = EMessageTypeConfig[notice_params_1.type].title || EBusinessMsgTypeConfig[notice_params_1.type].title;
                    _this.$message.error(title + " 没有查看详情权限");
                }
            });
            this.changeStatus(row, function () {
                _this.$emit("refresh");
            });
        }
        ;
    };
    MessageItem.prototype.changeStatus = function (row, cb) {
        var _this = this;
        this.service.changeStatus({ notice_id: row.notice_id }).then(function (res) {
            if (!res.data.success) {
                _this.$message.error(res.data.msg);
            }
            ;
            if (cb) {
                cb();
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    MessageItem.prototype.filterDownMsg = function (msg) {
        switch (msg.notice_params.type) {
            case DOWNLOAD_MSG.DOWNLOAD_MORE_10000:
            case DOWNLOAD_MSG.DOWNLOAD_MORE_10001:
            case DOWNLOAD_MSG.DOWNLOAD_MORE_10002:
                this.showDownTmpl(DownMessageTmpl, msg, {
                    title: "系统消息",
                    width: 450,
                    height: 300
                });
                break;
            default:
                break;
        }
    };
    MessageItem.prototype.showDownTmpl = function (msgTmpl, msg, dialogStyle) {
        var _this = this;
        var instance = this.$dialog(msgTmpl, {
            data: {
                msgDetail: msg
            }
        }, dialogStyle).instance;
        instance.$on("downLoad:ok", function (data) {
            _this.changeStatus(msg, function () {
                _this.$emit("refresh");
            });
        });
    };
    MessageItem.prototype.showDemandDetail = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var demandId, demandInfo, instance, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('🚀 开始显示商机详情弹窗');
                        console.log('- 消息数据:', msg);
                        console.log('- business_demand_id:', msg.notice_params.business_demand_id);
                        console.log('- order_id:', msg.notice_params.order_id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        demandId = msg.notice_params.business_demand_id || msg.notice_params.order_id || 'test_demand_123';
                        console.log('📋 准备获取商机详情，ID:', demandId);
                        return [4, this.getDemandInfo(demandId)];
                    case 2:
                        demandInfo = _a.sent();
                        console.log('📦 获取到商机详情数据:', demandInfo);
                        console.log('🎨 准备创建弹窗组件');
                        console.log('- DemandDetailDialog:', DemandDetailDialog);
                        console.log('- $dialog method:', this.$dialog);
                        instance = this.$dialog(DemandDetailDialog, {
                            propsData: {
                                demandInfo: demandInfo,
                                needPay: demandInfo.is_need_pay === 1,
                                isPaidUser: demandInfo.is_paid_user === 1
                            }
                        }, {
                            title: "采购需求详情",
                            width: 800,
                            height: 600,
                            customClass: 'demand-detail-modal'
                        }).instance;
                        console.log('✅ 弹窗组件已创建:', instance);
                        instance.$on("payment-success", function () {
                            _this.$message.success('支付成功！');
                            _this.refreshDemandDetail(msg);
                        });
                        instance.$on("refresh-content", function () {
                            _this.refreshDemandDetail(msg);
                        });
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.$message.error('获取商机详情失败');
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    MessageItem.prototype.getDemandInfo = function (demandId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.demandService.getDemandDetail(demandId)];
                    case 1:
                        response = _a.sent();
                        if (response.data.success) {
                            return [2, response.data.data];
                        }
                        else {
                            throw new Error(response.data.msg || '获取商机详情失败');
                        }
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.warn('API调用失败，使用模拟数据:', error_2);
                        return [2, {
                                title: "黄石市某供应链公司生鲜食材类供应商遴选",
                                c_time: "2025-08-28",
                                pv: 231,
                                project_name: "生鲜食材类供应商遴选",
                                requirements: "本项目采购6大类食材：蔬菜水产类、豆制品类、米油类、粉面类、鲜肉类及冻品类。",
                                budget: "1800万元（具体金额根据实际采购量和市场价格结算）",
                                procurement_method: "框架协议采购，每个分类入围供应商3家，入围供应商参与二次竞价确定供应量。",
                                contract_period: "2025年9月1日—2026年8月31日，合同期满后，根据供应商服务质量和公司需求，可协商续签。",
                                procurement_requirements: "\n                    <ul>\n                        <li>\u6EE1\u8DB3\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u653F\u5E9C\u91C7\u8D2D\u6CD5\u300B\u7B2C\u4E8C\u5341\u4E8C\u6761\u89C4\u5B9A\uFF1B</li>\n                        <li>\u5177\u6709\u72EC\u7ACB\u627F\u62C5\u6C11\u4E8B\u8D23\u4EFB\u7684\u80FD\u529B\uFF1B</li>\n                        <li>\u5177\u6709\u826F\u597D\u7684\u5546\u4E1A\u4FE1\u8A89\u548C\u5065\u5168\u7684\u8D22\u52A1\u4F1A\u8BA1\u5236\u5EA6\uFF1B</li>\n                        <li>\u5177\u6709\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\u8BBE\u5907\u548C\u4E13\u4E1A\u6280\u672F\u80FD\u529B\uFF1B</li>\n                        <li>\u6709\u4F9D\u6CD5\u7F34\u7EB3\u7A0E\u6536\u548C\u793E\u4F1A\u4FDD\u969C\u8D44\u91D1\u7684\u826F\u597D\u8BB0\u5F55\uFF1B</li>\n                    </ul>\n                ",
                                is_need_pay: 1,
                                is_paid_user: 0,
                                money: 4.9
                            }];
                    case 3: return [2];
                }
            });
        });
    };
    MessageItem.prototype.refreshDemandDetail = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log('刷新商机详情', msg);
                return [2];
            });
        });
    };
    __decorate([
        Prop({
            type: Object
        })
    ], MessageItem.prototype, "message", void 0);
    MessageItem = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth", "updateHomeShow"])),
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList',
                serviceFlag: 'serviceFlag'
            }))
        })
    ], MessageItem);
    return MessageItem;
}(Vue));
export default MessageItem;
